module.exports = __webpack_public_path__ + "f5df2e23ff6f7d6dae3f95db2091dfc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_xlarge_x1/public/history/8.jpg
// module id = 334
// module chunks = 0